<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import {
  getNameFilter,
  getEnabledFilter,
  getDomainFilter,
} from '@/utils/common/tableFilter'
import SingleActionMixin from './mixins/singleActions'
import ColumnsMixin from './mixins/columns'

export default {
  name: 'ReportSubscriptionList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionMixin],
  props: {
    resId: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'ReportDomainSubscriptionList',
        resource: 'report_subscriptions',
        getParams: this.getParam,
        apiVersion: 'v1',
        filterOptions: {
          name: getNameFilter(),
          enabled: getEnabledFilter(),
          project_domain: getDomainFilter(),
        },
      }),
      groupActions: [
        {
          label: this.$t('common.create'),
          action: () => {
            // const name = ''
            // const report_setting_id = this.resId

            // switch (report_setting_id) {
            //   case 'default_domain_report':
            //     name = 'ReportDomainSubscriptionCreate'
            //     break
            //   case 'default_project_report':
            //     name = 'ReportProjectSubscriptionCreate'
            //     break
            //   default:
            //     name = 'ReportCustomSubscriptionCreate'
            //     break
            // }

            // this.$router.push({
            //   name,
            //   query: {
            //     report_setting_id,
            //   },
            // })
            this.createDialog('ReportSubscriptionCreateDialog', {
              report_setting_id: this.resId,
              columns: this.columns,
              data: this.list.selectedItems,
              onManager: this.onManager,
              ok: () => {
                this.list.fetchData()
              },
            })
          },
          meta: () => {
            const report_setting_id = this.resId
            return {
              buttonType: 'primary',
              validate: !!report_setting_id,
            }
          },
        },
        {
          label: this.$t('common.batchAction'),
          actions: () => {
            return [
              {
                label: this.$t('report.action.enable'),
                action: () => {
                  this.list.batchPerformAction('enable', null)
                },
                meta: () => {
                  const validate = this.list.selectedItems.length && this.list.selectedItems.some(item => !item.enabled)
                  return {
                    validate,
                    tooltip: !validate ? this.$t('report.subscription_validate_disable') : '',
                  }
                },
              },
              {
                label: this.$t('report.action.disabled'),
                action: () => {
                  this.createDialog('SubscriptionSetDisabledDialog', {
                    columns: this.columns,
                    data: this.list.selectedItems,
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  const validate = this.list.selectedItems.length && this.list.selectedItems.some(item => item.enabled)
                  return {
                    validate,
                    tooltip: !validate ? this.$t('report.subscription_validate_enable') : '',
                  }
                },
              },
              {
                label: this.$t('cloudenv.text_108'),
                action: () => {
                  this.createDialog('DeleteResDialog', {
                    vm: this,
                    data: this.list.selectedItems,
                    columns: this.columns,
                    title: this.$t('common.delete'),
                    name: this.$t('report.subscription'),
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  const validate = this.list.selectedItems.length
                  return {
                    // validate: this.list.allowDelete(),
                    validate,
                    tooltip: !validate ? this.$t('report.subscription_validate_delete') : '',
                  }
                },
              },
            ]
          },
        },
      ],
      exportDataOptions: {
        items: [
          { label: this.$t('table.title.name'), key: 'name' },
          { label: this.$t('table.title.enable_status'), key: 'enabled' },
          { label: this.$t('report.subscription_scope'), key: 'project_domain' },
          { label: this.$t('common.billing_scope'), key: 'data_scope' },
          { label: this.$t('common.createdAt'), key: 'created_at' },
        ],
      },
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ReportDomainSubscriptionListSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
    getParam () {
      const notCustom = ['default_domain_report', 'default_project_report']
      if (!notCustom.includes(this.resId)) {
        return {
          'filter.0': `report_setting_id.notin(${notCustom.join(',')})`,
        }
      }
      return {
        'filter.0': `report_setting_id.in(${this.resId})`,
      }
    },
  },
}
</script>
